import {createRouter, createWebHistory} from "vue-router";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        // {
        //     path: "/",
        //     // component: () => import("../components/HomeCmp.vue"),
        //     component: () => import("../components/QLogin.vue"),
        // },
        {
            path: "/home",
            component: () => import("../components/HomeCmp.vue"),
        },
        // {
        //     path: "/register",
        //     component: () => import("../components/QGen.vue"),
        //     // component: () => import("../components/RegisterCmp.vue"),
        // },
        {
            path: "/login-qr",
            component: () => import("../components/QLoginQR.vue"),
        },
        // {
        //     path: "/sign-in",
        //     component: () => import("../components/QLogin.vue"),
            // component: () => import("../components/SignIn.vue"),
        // },
        // {
        //     path: "/feed",
        //     component: () => import("../components/FeedCmp.vue"),
        // },
        {
            // path: "/addresses",
            // component: () => import("../components/AddressBook.vue"),
        },
        {
            path: "/ceremonie",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "ceremonie"}
        },
        {
            path: "/sleep",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "sleep"}
        },
        {
            path: "/lieu",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "lieu"}
        },
        {
            path: "/date",
            // component: () => import("../components/BasicInfo.vue"),
            component: () => import("../components/QDate.vue"),
            props: {namedEntry: "date"}
        },
        {
            path: "/menu",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "menu"}
        },
        {
            path: "/activity",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "activity"}
        },
        {
            path: "/noce",
            component: () => import("../components/BasicInfo.vue"),
            props: {namedEntry: "noce"}
        },
        {
            path: "/gallery",
            component: () => import("../components/QGallery.vue"),
        },
        {
            path: "/take-photo",
            component: () => import("../components/TakePhotoCmp.vue"),
        },
        // {
        //     path: "/confirm",
        //     component: () => import("../components/QFeedbacks.vue"),
        // },
        // {
        //     path: "/guestbook",
        //     component: () => import("../components/GBook.vue"),
        // },
    ],
});

export default router;
